<template>
  <div>
    <p v-if="!loadingAttachments && this.checkIfUplodSettingsExists" class="attachments-info">
      Maksymalny rozmiar pojedynczego wgrywanego pliku operatu nie może przekroczyć {{this.uploadSettings.max_size}} MB.
    </p>
    <div
      v-if="filePath"
      id="attachments-container"
    >
      <Viewer :attachments="viewMode ? attachments : filteredAttachmentsForViewer" :service="service"/>
      <blocking-loader
        :type="'download'"
        :progress="loadingProgress"
        :show="loadingAttachments"
      >
        <p>{{ $t('pages.taskDetails.attachments.loadingAttachments') }}</p>
      </blocking-loader>
      <blocking-loader
        :show="downloadingAttachments"
      >
        <p>{{ $t('pages.taskDetails.attachments.downloadingAttachments') }}</p>
      </blocking-loader>
      <blocking-loader
        :type="'download'"
        :progress="Math.floor((processingImagesCount.length / imagesToProcess) * 100)"
        :show="uploadingAttachments"
      >
        <p>{{ $t('pages.taskDetails.attachments.processingAttachments') }}</p>
      </blocking-loader>
      <blocking-loader
        :show="changingCategory"
      >
        <p>{{ $t('pages.taskDetails.attachments.changingCategory') }}</p>
      </blocking-loader>
      <blocking-loader
        :show="sendingToAudanet"
      >
        <p>{{ $t('pages.taskDetails.attachments.sendingToAudanet') }}</p>
      </blocking-loader>
      <confirm-modal
        title=""
        :subject="selected"
        :show="deleteItemsModalVisible"
        @close="deleteItemsModalVisible = false"
        @cancel="deleteItemsModalVisible = false"
        @confirm="startRemoveAttachments"
      >
        Czy na pewno chcesz usunąć?
      </confirm-modal>
      <template v-if="viewMode">
        <ViewOnlyContainer
          :taskNumber="taskNumber"
          :attachments="attachments"
          :task-type="taskType"
          :service="service"
          @preview="({e, singleAttachment}) => preview(e, singleAttachment)"
        ></ViewOnlyContainer>
      </template>
      <template v-if="!viewMode">
        <div class="categories-container-list">
          <div v-for="(categoriesMap, index) in sortedAndGroupedCategories" :key="`categories-group-${index}`">
            <template v-for="category in categoriesMap">
              <transition
                v-if="containsHiddenCategoryAction(category.id)"
                name="slide-right-centered"
                :key="`transition-${category.id}`"
              >
                <div
                  :id="`category-box-${category.id}`"
                  :key="category.id"
                  class="category-box"
                  :class="{'active-category': currentCategory === category.id}"
                  :style="{
          }"
                >
                  <div>
                    <tooltip
                      :text="category.description"
                      :enterable="false"
                      placement="right"
                    >
                      <div
                        class="folder-imitation"
                        :class="{'category-required': requiredCategories.includes(category.id) && !categoryAttachmentsCount(category.id)}"
                        :style="{
              }"
                      >
                        <p
                          :title="$t(category.name).includes('.') ? $t(category.name).split('.').join(' ') : $t(category.name)">
                          {{
                            $t(category.name).includes('.') ? $t(category.name).split('.').join(' ') : $t(category.name)
                          }}</p>
                        {{ ' ' }}
                      </div>
                      <div
                        class="category-container"
                        :class="{'category-required': requiredCategories.includes(category.id) && !categoryAttachmentsCount(category.id)}"
                        :style="{
              }"
                        @click="(event) => handleChangeCategoryPreview(category.id, event)"
                        @dragover="dragover_handler"
                        @drop="(event) => handleChangeCategory(event, category.id)"
                      >
                        <strong>{{ categoryAttachmentsCount(category.id) }}</strong>
                      </div>
                    </tooltip>
                  </div>
                </div>
              </transition>
            </template>
            <div class="categories-group-separator"></div>
          </div>
        </div>
        <div class="categories-container">
          <div
            v-for="category in selectedCategory"
            :id="`category-box-${category.id}`"
            :key="category.id"
            class=""
            :style="{
            position: currentCategory === category.id ? categoryPosition : 'initial',
            top: categoryTopPosition,
            transition: currentCategory === category.id ? `all ease ${categoryTransitionTime}s` : `all ease 1s`
          }"
          >
            <div>
              <div
                class="folder-imitation"
                :class="{'category-required': requiredCategories.includes(category.id) && !categoryAttachmentsCount(category.id)}"
              >
                <p>{{
                    $t(category.name).includes('.') ? $t(category.name).split('.').join(' ') : $t(category.name)
                  }}</p>
                {{ ' ' }}
              </div>
              <div
                class="category-container-opened"
                :class="{'category-required': requiredCategories.includes(category.id) && !categoryAttachmentsCount(category.id)}"
                :style="{
                background: currentCategory === category.id ? 'rgb(161, 179, 209)' : '#ffdfba',
                minHeight: currentCategory === category.id ? '65vh' : '11rem',
                maxHeight: currentCategory === category.id ? '65vh' : '11rem',
                cursor: currentCategory === category.id ? 'auto' : 'pointer'
              }"
              >
                <div
                  v-if="currentCategory === category.id"
                  class="attachments-preview-container"
                >
                  <div
                    v-for="singleAttachment in filteredAttachments"
                    :key="singleAttachment.id"
                    @click.ctrl="() => {
                    lastSelectedAttachment = singleAttachment.id
                    toggleItem(singleAttachment.id)
                  }"
                    @click.shift.exact="() => toggleItems(singleAttachment.id, filteredAttachments)"
                  >
                    <div
                      :draggable="isAllowedToEdit"
                      class="attachments--item"
                      @dragstart="(event) => dragstart_handler(event, singleAttachment)"
                    >
                      <div
                        class="attachments--item-select"
                      >
                        <div @click="() => toggleItem(singleAttachment.id)">
                          <input
                            :id="singleAttachment.id"
                            type="checkbox"
                            name="selected"
                            :checked="selected.includes(singleAttachment.id)"
                            @click="() => {
                          lastSelectedAttachment = singleAttachment.id
                          toggleItem(singleAttachment.id)
                        }"
                          >
                          <label :for="singleAttachment.id"/>
                        </div>

                        <!--                        <i v-if="allowRotate && isImage(singleAttachment)" @click="(event) => editImage(event, singleAttachment)" class="feather-edit edit-attachment-icon"></i>-->
                      </div>
                      <popover
                        :tag="'div'"
                        :auto-placement="true"
                        trigger="hover"
                        :key="`popver-${singleAttachment.id}`"
                        class="attachment--item--container"
                      >
                        <template slot="popover">
                          <div class="box box-component box-info">
                            <p class="tooltip-name">
                              <strong>Nazwa:</strong> {{ singleAttachment.filename }}
                            </p>
                            <p><strong>Autor:</strong> {{ singleAttachment.createdBy }}</p>
                            <p><strong>Dodano:</strong> {{ singleAttachment.createdAt }}</p>
                          </div>
                        </template>
                        <img
                          :id="singleAttachment.id"
                          :src="singleAttachment.value"
                          @click.exact="(e) => preview(e, singleAttachment)"
                        >
                        <p
                          class="attachment--item-title"
                          :title="singleAttachment.filename"
                        >
                          {{ singleAttachment.filename }}
                        </p>
                      </popover>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>


      <form
        ref="form"
        class="attachments--file-form"
        enctype="multipart/form-data"
      >
        <input
          ref="file"
          type="file"
          class="attachments--file-input"
          multiple
          accept=".doc, .docx, .rtf, .pdf, .ods, .odt, .xls, .xlsx, .csv, .txt, .eml, .msg, .xlsm, .7z, .zip, .rar, .gz, .tar, .bmp, .jpeg, .jpg, .tif, .tiff, .png, .PNG, .gif, xml, .signPro, .SIGNPR, .DWG, .crw, .ath, .szf, .axx, .xades, .GPG, .pgp, .sig, .sko, .eie, .sie, .mp3"
          @change="uploadFiles"
        >
      </form>
    </div>
    <div v-else>
      <h3 class="tab-header">
        Załączniki
      </h3>
      <p class="content-empty">
        Nie ma jeszcze załączników
      </p>
    </div>
    <!--    <base-simple-modal-->
    <!--      class="edit-modal"-->
    <!--      v-if="editModalVisible"-->
    <!--      :show="editModalVisible"-->
    <!--      :subject="[[],'']"-->
    <!--      @close="editModalVisible = false"-->
    <!--    >-->
    <!--      <Editor-->
    <!--        class="image-editor modal-dialog modal-md"-->
    <!--        v-if="options.includeUI.loadImage && options.includeUI.loadImage.path"-->
    <!--        :options="options"-->
    <!--        @sendEditedFile="(image) => sendEditedFile(image)"-->
    <!--        @close="editModalVisible = false"-->
    <!--      />-->
    <!--    </base-simple-modal>-->
    <ZipPasswordModal
      :service="service"
      :file-uuids="fileUuidsToEncrypt"
      :taskNumber="taskNumber"
      :show="encryptModalOpened"
      @close="closeEncryptModal"
      @success="closeEncryptModal"
    >
    </ZipPasswordModal>
  </div>
</template>
<script>
import {mapActions, mapState} from 'vuex'
import api from '../../../../../api'
// import BaseSimpleModal from '../../../../share/modal/BaseSimpleModal'
import BlockingLoader from '../../../../share/BlockingLoader'
import buttons from './mixins/buttons'
import ConfirmModal from '../../../../share/modal/BaseConfirmModal'
import errorReporter from '../../../../../store/attachmentsState/utils/errorReporter'
import events from './mixins/events'
import IsImage from '../../../../../store/attachmentsState/utils/IsImage'
import removingAttachments from './mixins/removingAttachments'
import selectingAttachments from './mixins/selectingAttachments'
import sortedCategoriesMixin from './mixins/sortedCategoriesMixin'
import Thumb from '../../../../../store/attachmentsState/utils/Thumb'
import tooltipHandling from './mixins/tooltipHandling'
import {Popover, Tooltip} from 'uiv'
import Viewer from './view/Viewer'
import ViewOnlyContainer from './view/ViewOnlyContainer'
import visibilityRules from './mixins/visibilityRules'
import ZipPasswordModal from './modals/ZipPasswordModal'
import moment from 'moment'

export default {
  components: {
    ZipPasswordModal,
    // BaseSimpleModal,
    // Editor: () => import('./editor/Editor'),
    ViewOnlyContainer,
    Tooltip,
    Popover,
    ConfirmModal,
    BlockingLoader,
    Viewer
  },
  mixins: [
    events,
    visibilityRules,
    tooltipHandling,
    buttons,
    sortedCategoriesMixin,
    selectingAttachments,
    removingAttachments
  ],
  props: {
    taskType: {
      type: String, default () {
        return 'main'
      }
    },
    service: {
      type: String, default () {
        return ''
      }
    },
    activeTab: {type: String, required: true},
    path: {type: String, required: true},
    filePaths: {type: Array, required: true, default: () => []},
    filePath: {type: String, required: true},
    taskNumber: {type: String, required: true},
    subtasks: {
      type: Array, default () {
        return []
      }
    },
    taskId: {
      type: Number, default () {
        return 0
      }
    },
    taskState: {
      type: Object, required: true, default: () => {
      }
    },
    workflowId: {type: Number, required: true},
    withCategoryRequirements: {type: Boolean, default: () => false}
  },
  data () {
    return {
      options: { // for tui-image-editor component's "options" prop
        includeUI: {},
        cssMaxWidth: 700,
        cssMaxHeight: 500,
        usageStatistics: false
      },
      // categories: [{name: 'default', id: 0},{name: 'cat1', id: 1}, {name: 'cat2', id: 2}],
      currentCategory: null,
      categoryTopPosition: '30%',
      categoryPosition: 'sticky',
      categoryLeftPosition: '35%',
      categoryTransitionTime: 0,
      dragImage: null,
      viewMode: false,
      editModalVisible: false,
      encryptModalOpened: false,
      fileUuidsToEncrypt: [],
      uploadSettings: {}
    }
  },
  computed: {
    ...mapState({
      categories: state => state.attachments.categories,
      requiredCategories: state => state.attachments.requiredCategories,
      attachments: state => state.attachments.attachments,
      currentlyDownloadedFile: state => state.attachments.currentlyDownloadedFile,
      numberOfFilesToDownload: state => state.attachments.numberOfFilesToDownload,
      downloadedFiles: state => state.attachments.downloadedFiles,
      loadingAttachments: state => state.attachments.loadingAttachments,
      downloadingAttachments: state => state.attachments.downloadingAttachments,
      uploadingAttachments: state => state.attachments.uploadingAttachments,
      changingCategory: state => state.attachments.changingCategory,
      sendingToAudanet: state => state.attachments.sendingToAudanet,
      processingImagesCount: state => state.attachments.processingImagesCount,
      sendingCount: state => state.attachments.sendingCount,
      processingImages: state => state.attachments.processingImages,
      imagesToProcess: state => state.attachments.imagesToProcess
    }),
    loadingProgress () {
      if (this.currentlyDownloadedFileAmount === 0) {
        return 0
      }
      return Math.floor((this.currentlyDownloadedFileAmount / this.numberOfFilesToDownload) * 100)
    },
    currentlyDownloadedFileAmount () {
      return this.currentlyDownloadedFile.length
    },
    filteredAttachments () {
      const sorting = {
          alphaNum: (a, b) => a.filename.localeCompare(b.filename, 'pl', { numeric: true }),
          createdAndFilename: (a, b) => (a.createdAt.substring(0,13) + a.filename).localeCompare(b.createdAt.substring(0,13) + b.filename, 'pl', { numeric: true }),
          date: (a, b) => moment(a.createdAt).valueOf() > moment(b.createdAt).valueOf() ? 1 : -1
      }
      return Object.entries(this.attachments).filter(
        ([key, value], index) => value.category === this.currentCategory).map(([key, value], index) => {
        value.uuid = key
        return value
      }).sort(sorting.createdAndFilename)
    },
    filteredAttachmentsForViewer () {
      let attachmentsForViewerObj = {}
      const sorting = {
          alphaNum: (a, b) => a.filename.localeCompare(b.filename, 'pl', { numeric: true }),
          createdAndFilename: (a, b) => (a.createdAt.substring(0,13) + a.filename).localeCompare(b.createdAt.substring(0,13) + b.filename, 'pl', { numeric: true }),
          date: (a, b) => moment(a.createdAt).valueOf() > moment(b.createdAt).valueOf() ? 1 : -1
      }

      Object.entries(this.attachments).filter(
        ([key, value], index) => value.category === this.currentCategory).map(([key, value], index) => {
        value.uuid = key
        return value
      }).sort(sorting.createdAndFilename).forEach((att, index) => attachmentsForViewerObj[att.uuid] = att)
      return attachmentsForViewerObj
    },
    selectedCategory () {
      return this.categories.filter(cat => cat.id === this.currentCategory)
    },
    allowRemove () {
      return this.$auth.isAllowed({service: [this.service, 'storage'], action: 'delete_files'})
    },
    allowRotate () {
      return this.$auth.isAllowed({service: [this.service, 'storage'], action: 'put_files'})
    }

  },
  watch: {
    attachments: function (newVal) {
      this.$emit('attachments-count-changed'),
      this.getUploadSetings()
    },
    currentlyDownloadedFileAmount: function (newVal) {
      if (newVal === this.numberOfFilesToDownload) {
        let filesClone = this.downloadedFiles
        this.$store.commit('SET_DOWNLOADED_FILES', [])
        if (Array.isArray(filesClone)) {
          this.prepareAttachments(filesClone)
          this.$store.dispatch('loadAssignedCategories', {
            service: this.service,
            $events: this.$events,
            $notify: this.$notify
          })
        } else {
          this.$store.commit('SET_CURRENTLY_DOWNLOADED_FILE', [])
        }
      }
    },
    sendingCount: function (newVal) {
      let service = this.service
      let filePaths = this.filePaths
      let canEditAttachments = true
      if (newVal === this.imagesToProcess) {
        this.$store.commit('SET_DOWNLOADED_FILES', [])
        this.$store.commit('SET_UPLOADING_ATTACHMENTS', false)

        if (!this.$store.state.attachments.updating) {
          this.$store.dispatch('loadAttachments', {service, filePaths, canEditAttachments, $notify: this.$notify})
        }

        this.$refs.file.value = []
      }
    }
  },
  beforeDestroy () {
    this.exitAttachments()
  },
  async mounted () {
    this.$store.commit('SET_LOADING_ATTACHMENTS', true)
    await this.getAllCategories()
    if (this.$auth.isAllowed({service: this.service, action: 'get_attachment_category_sections'})) {
      await this.getSections()
    }
    if (this.filePath) {
      this.$showThirdMenu('attachments')
      this.getDragImage()
      this.$getEvents()
      this.$listenToEvents()
      if (this.withCategoryRequirements) {
        await this.getCategoryRequirements({
          service: this.service,
          taskType: this.taskType,
          id: this.taskId,
          $notify: this.$notify
        })
      }
      await this.loadAttachments({
        service: this.service, filePaths: this.filePaths, canEditAttachments: true, $notify: this.$notify
      })
    }
  },
  methods: {
    ...mapActions([
      'sendAttachmentFiles',
      'loadCategories',
      'getCategoryRequirements',
      'loadAttachments',
      'sendAttachmentCategory',
      'exitAttachments',
      'actionDelete',
      'actionDownload',
      'sendToAudanet',
      'rotate',
      'sendSingleToBackend'
    ]),
    editImage (event, singleAttachment) {
      const callOpenEditModal = () => {
        let newOptions = {...this.options}
        newOptions.attachment = singleAttachment
        newOptions.includeUI.loadImage = {}
        newOptions.includeUI.loadImage.path = singleAttachment.value
        newOptions.includeUI.loadImage.name = singleAttachment.filename
        this.options = newOptions

        this.editModalVisible = true
      }
      if (!singleAttachment.fullSize) {
        this.getFullSizeImage(singleAttachment, callOpenEditModal)
        return
      }
      callOpenEditModal()
    },
    preview (event, attachment) {
      if (attachment.mimeType.match(/image.*/)  && attachment.mimeType !== 'image/tiff') {
        this.$events.emit('startPreview', event, attachment)
      }
    },
    prepareAttachments (data) {
      let list = {}
      data.forEach((el) => {
        el.hidden = false
        list[el.id] = el
      })
      this.$store.commit('SET_ATTACHMENTS_STATE', list)
      // this.attachments = list
      Object.entries(this.attachments).forEach(el => {
        if (this.$store.state.attachments.attachmentsCache[el[0]]) {
          return
        }
        this.$store.commit('SET_ALL_ATTACHMENTS_CACHE', el)
      })
    },
    categoryAttachmentsCount (id) {
      return Object.entries(this.attachments).filter(([key, value], index) => value.category === id).length
    },
    getPosition (id) {
      return this.currentCategory === id ? 'relative' : 'inherit'
    },
    async getAllCategories () {
      await this.loadCategories({
        service: this.service,
        $events: this.$events,
        $notify: this.$notify
      })
    },
    handleChangeCategoryPreview (id, event) {
      this.selected = []
      this.currentCategory = id
      this.categoryPosition = 'sticky'
      setTimeout(() => {
        this.categoryPosition = 'sticky'
      }, 100)
    },
    handleChangeCategory (ev, id) {
      ev.preventDefault()
      if (ev.dataTransfer.types.includes('attachment')) {
        let receivedData = JSON.parse(ev.dataTransfer.getData('attachment'))
        this.sendAttachmentCategory({
          service: this.service,
          receivedData,
          data: receivedData,
          categoryId: id,
          $notify: this.$notify,
          task: this.taskId
        })
        this.selected = []
        return
      } else if (ev.dataTransfer.types.includes('attachments')) {
        let receivedData = JSON.parse(ev.dataTransfer.getData('attachments'))
        for (let element in receivedData) {
          this.sendAttachmentCategory({
            service: this.service,
            data: receivedData[element],
            categoryId: id,
            $notify: this.$notify,
            task: this.taskId
          })
        }
        this.selected = []
      }
    },
    getDragImage () {
      let img = new Image(200, 200)
      img.src = 'data:image/png;base64,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'
      this.dragImage = img
    },
    dragstart_handler (ev, attachment) {
      if (!this.isAllowedToEdit) {
        return
      }
      const noop = function () {
        return
      }
      // Add the target element's id to the data transfer object
      if (this.selected.length <= 1 || !this.selected.includes(attachment.id)) {
        ev.dataTransfer.setData('attachment', JSON.stringify(attachment))
        return
      }
      let attToDrag = {}
      for (let element in this.attachments) {
        this.selected.includes(element) ? attToDrag[element] = this.attachments[element] : noop()
      }
      ev.dataTransfer.setData('attachments', JSON.stringify(attToDrag))
      ev.dataTransfer.setDragImage(this.dragImage, 2, 2)
      ev.dataTransfer.dropEffect = 'move'

    },
    dragover_handler (ev) {
      ev.preventDefault()
      ev.dataTransfer.dropEffect = 'move'
    },
    toggleAttachmentsView () {
      if (this.viewMode) {
        this.viewMode = false
        this.getButtons()
        this.$showThirdMenu('attachments')
      } else {
        this.viewMode = true
        this.getViewModeButtons()
        this.$showThirdMenu('attachments')
      }
    },
    invertSelection () {
      this.filteredAttachments.forEach(attachment => this.toggleItem(attachment.id))
    },
    addFilesToForm () {
      this.$refs.file.click()
    },
    initSendToAudanet () {
      this.sendToAudanet({
        service: this.service,
        taskId: this.taskId,
        $notify: this.$notify,
        isWithClients: this.$isWithClients(this.service)
      })
    },
    isImage (file) {
      return IsImage.isImage(file.mimeType)
    },
    sendEditedFile (image) {
      this.options.attachment.value = image
      let data = {
        uuid: this.options.attachment.uuid,
        data: this.options.attachment,
        service: this.service,
        filePath: this.filePath,
        filePaths: this.filePaths,
        canEditAttachments: true,
        $notify: this.$notify,
        taskId: this.taskId,
        fileRef: this.fileRef,
        categoryId: this.options.attachment.category,
        edit: true
      }
      this.sendSingleToBackend(data)
      this.editModalVisible = false
    },
    download () {
      let uuids = Object.keys(this.attachments)
      if (this.$store.state.base.user.isAttachmentPassword) {
        this.fileUuidsToEncrypt = uuids
        this.openEncryptModal()
        return
      }
      this.actionDownload({uuids: uuids, service: this.service, taskNumber: this.taskNumber})
    },
    openEncryptModal () {
      this.encryptModalOpened = true
    },
    closeEncryptModal () {
      this.encryptModalOpened = false
      this.fileUuidsToEncrypt = []
    },
    uploadFiles (event) {
      let files = event.target.files || event.dataTransfer.files
      if (!files.length) {
        return
      }
      this.sendAttachmentFiles(
        {
          files, service: this.service,
          filePath: this.filePath,
          filePaths: this.filePaths,
          canEditAttachments: true,
          $notify: this.$notify,
          taskId: this.taskId,
          fileRef: this.$refs.file
        }
      )
    },
    getFullSizeImage (att, callFunction) {
      api.request('storage', 'get', `/download/${this.service}?filter=uuids&fileUuids=${att.id || att.uuid}`)
        .then((response) => {
          att.value = response.data.value
          att.value = Thumb.getNewSrc(att)
          this.$store.dispatch('fullImageDownloaded', {
            id: att.id || att.uuid,
            value: att.value
          })
          att.type = att.mimeType
          att.name = att.filename
          let event = {target: {result: att.value}}
          callFunction(event, att)
          this.selected = []
        })
        .catch((e) => {
          this.selected = []
          errorReporter.reportError(e)
          this.$notify({
            type: 'error',
            title: 'Wystąpił błąd',
            text: `Nie można pobrać pliku ${att.filename}`
          })
        })
    },
    getUploadSetings() {
      api.request('storage', 'get', `/upload_settings/${this.service}`)
        .then((response) => {
          this.uploadSettings = response.data
        })
        .catch((e) => {
          this.errorNotify()
          })
    }},
    rotateAttachments () {
      let attachmentsToRotate = this.selected.map(uuid => this.attachments[uuid])
      if (attachmentsToRotate.length === 0) {
        return
      }
      this.$store.commit('SET_UPDATING_ATTACHMENTS', true)
      this.$store.commit('SET_SENDING_COUNT', 0)
      this.$store.commit('CLEAR_SENT_SUMMARIES')
      this.$store.commit('SET_UPLOADING_ATTACHMENTS', true)
      this.$store.commit('SET_IMAGES_TO_PROCESS', attachmentsToRotate.length)
      this.$store.commit('CLEAR_PROCESSING_IMAGES_PROGRESS')
      const callRotate = (event, attachment) => {
        this.rotate({
          event,
          file: attachment,
          uuid: attachment.id || attachment.uuid,
          service: this.service,
          filePath: this.filePath,
          filePaths: this.filePaths,
          canEditAttachments: true,
          $notify: this.$notify,
          taskId: this.taskId,
          fileRef: this.fileRef,
          rotateMode: 6
        })
      }

      attachmentsToRotate.forEach(att => {
        if (!att.fullSize) {
          this.getFullSizeImage(att, callRotate)
        } else {
          att.type = att.mimeType
          att.name = att.filename
          let event = {target: {result: att.value}}
          callRotate(event, att)
        }
      })
    },
    startRemoveAttachments () {
      this.deleteItemsModalVisible = false
      this.actionDelete({uuids: this.selected, service: this.service, $notify: this.$notify})
    },
    fileName (file) {
      if (file.filename.length > 20) {
        return file.filename.slice(0, 20) + '...'
      } else {
        return file.filename
      }
    }
  }
</script>

<style lang="scss">

/*@import '~tui-image-editor/dist/tui-image-editor.min.css';*/
/*@import '~tui-color-picker/dist/tui-color-picker.min.css';*/
.attachments-info {
  text-align: center;
  font-size: 0.9em;
  font-weight: 600;
  color: $errorColor;
  margin: 5px
}
#attachments-container {
  display: flex;
}

.categories-container-list {
  width: 25%;
}

.categories-container-list div:first-child .category-box:first-child {
  width: 92%;
}

.category-box {
  width: 45%;
}

.categories-container {
  width: 75%
}

.categories-container {
}

.category-box {
  margin: 1%;
  float: left;
}

.category-container-opened {
  transition: all ease 1s;
  word-break: break-word;
  cursor: pointer;
  background: #ccd;
  border: 2px solid #ccd;
  border-radius: 2px;
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  font-size: 10px;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

.category-container {
  transition: all ease 1s;
  word-break: break-word;
  cursor: pointer;
  background: #e6f1f7;
  border: 1px solid #ccd;
  border-radius: 2px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 30px;
  color: #4e5567;
}

#attachments-container .category-box.active-category .category-container {
  background: rgb(161, 179, 209);
}

.categories-container-list > div:not(:last-child) .categories-group-separator {
  float: left;
  width: 92%;
  margin: 1%;
  border-bottom: 3px solid #42a5ff;
}

.categories-container-list > div:nth-child(2) .category-container {
  background: #42A5F6;
}

.categories-container-list > div:nth-child(3) .category-container {
  background: #6cc6f6;
}

.categories-container-list > div:nth-child(4) .category-container {
  background: #97d9f5;
}

.folder-imitation {
  height: 29px;
  background: #e6f1f7;
  border-left: 1px solid #ccd;
  border-top: 1px solid #ccd;
  border-right: 1px solid #ccd;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: 1px solid #ccd;
  font-size: 11px;
  line-height: 11px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.folder-imitation.category-required {
  border-top: red 1px solid;
  border-right: red 1px solid;
  border-left: red 1px solid;
  background: #ffe4f0;
}

.folder-imitation p {
  margin: 5px 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.attachment--item-title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.category-container-opened.category-required, .category-container.category-required {
  border-bottom: red 1px solid;
  border-right: red 1px solid;
  border-left: red 1px solid;
}

.single-attachment-container {
  height: 10rem;
  width: 10rem;
  background: #00fff7;
  margin: 1rem;
}

.attachments-preview-container {
  display: flex;
  flex-wrap: wrap;
}

.slide-right-centered-enter,
.slide-right-centered-leave-to {
  transform: scale(1, 1) translate(300%);
  opacity: 0;
}

.slide-right-centered-enter-active {
  transition: transform .2s ease, opacity 0.8s ease;
}

.slide-right-centered-leave-active {
  position: absolute;
  transition: transform .2s ease, opacity 0.8s ease;
}

.attachments--item {
  height: 160px;
  width: 160px;
}

.attachments--item img {
  max-height: 85px;
  max-width: 155px;
  cursor: pointer;
}

.attachment--item--container {
  padding-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.attachment--item--container p {
  font-size: 11px;
  max-width: 130px;
}

.category-container-opened .attachments--item-select > label:before {
  height: 15px;
  width: 15px;
}

.image-editor {
  margin: auto;
  width: auto;
}

.modal-content {
  margin-top: 0;
}

.edit-modal > .modal-dialog {
  width: auto;
  height: auto;
}

.edit-modal .modal-footer {
  border-top: 0px solid #e5e5e5;
}

#attachments-container .attachments--item-select {
  display: flex;
  justify-content: space-between;
  height: 20px;
  width: 140px;
  position: absolute;
  left: 10px;
  top: 0px;
  line-height: 0;
}

#attachments-container .attachments--item-select input[type="checkbox"] + label {
  padding-left: 0 !important;
  margin-left: 0;
  margin-top: 5px;
}

#attachments-container .attachments--item-select input[type="checkbox"] + label:before {
  height: 17px;
}

#attachments-container .attachments--item-select input[type="checkbox"]:not(:checked) + label:before {
  width: 17px;
}

#attachments-container .edit-attachment-icon {
  cursor: pointer;
  position: relative;
  top: 5px;
  font-size: 15px;
}

.tooltip-name {
  word-break: break-word;
}
</style>
